import * as React from "react";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import * as cls from "./modalAnket.module.scss";
import { StudentService } from "../studentService";
import { Icon } from "../../../personal-studio-components/frame";
import Answers from "./Answers";
import { ErrataView } from "../../../personal-studio-components/service";
import { ErrataViewInfo } from "../../../personal-studio-components/service/ErrataViewInfo";
import LinearLoader from "../linearLoader/LinearLoader";
export default function Anket({
  anketa_id,
  getDetail,
  handleAgreement,
  planning_event_id,
}) {
  const { access_token } = useSelector((state) => state.token);
  const { contractId } = useSelector((state) => state.contract);
  const [anketData, setAnketData] = useState(null);
  const [selectedAnswerIndex, setSelectedAnswerIndex] = useState(null);
  const [editedData, setEditedData] = useState(null);
  const [currentQuestion, setCurrentQuestion] = useState(null);
  const [currentQuestionId, setCurrentQuestionId] = useState(null);
  const [nextQuestionId, setNextQuestionId] = useState(false);
  const [answerId, setAnswerId] = useState(null);
  const [comments, setComments] = useState({});
  const [isNeedDetails, setIsNeedDetails] = useState(false);
  const [isFormFilled, setIsFormFilled] = useState(false);
  const [isShowFinalMessage, setIsShowFinalMessage] = useState(false);
  const [questionIdsHistory, setQuestionIdsHistory] = useState([]);
  const [isSaveLoading, setIsSaveLoading] = useState(false);
  const [checkedAnswers, setCheckedAnswers] = useState([]);
  const [showRequireFieldError, setShowRequireFieldError] = useState(false);
  const [readonly, setReadonly] = useState(false);
  async function getAnket() {
    const request = {
      method: "post",
      path: "/student/inquirer/load",
      data: {
        access_token,
        study_contract_id: contractId,
        anketa_id: anketa_id,
        planning_event_id,
      },
    };
    await StudentService.send(request, (response) => {
      if (response) {
        setAnketData(response);
        if (!response.errors) {
          setReadonly(response.is_completed);
          setEditedData(response);
          setCurrentQuestion(response.questions[0]);
        }
      }
    });
  }

  async function saveAnket(e) {
    e.preventDefault();
    e.stopPropagation();
    const clearEditedData = JSON.parse(JSON.stringify(editedData));

    clearEditedData.questions = clearEditedData.questions.filter((el) => {
      if (questionIdsHistory.includes(el.question_id)) return true;
      return false;
    });

    clearEditedData.questions = clearEditedData.questions.filter((el) => {
      const filteredAnswers = el.answers.filter((item) => item.markAsAnswer);
      if (filteredAnswers.length > 0) {
        el.answers = filteredAnswers;
        return true;
      }
      return false;
    });

    clearEditedData.questions.forEach((question) => {
      question.answers.forEach((answer) => {
        if (answer.markAsAnswer && comments[answer.answer_id]) {
          answer.details = comments[answer.answer_id];
        }
      });
    });

    const request = {
      method: "post",
      path: "/student/inquirer/save",
      data: {
        access_token,
        study_contract_id: contractId,
        data: clearEditedData,
      },
    };
    setIsSaveLoading(true);
    const data = await StudentService.send(request, (response) => {
      setAnketData(response);
      setIsShowFinalMessage(true);
    });
    if (!data.errors) {
      setIsShowFinalMessage(true);
      const response = await handleAgreement();
      if (!response.errors) {
        await getDetail();
      }
    }
    setIsSaveLoading(false);
  }

  const handleAnswerSelection = (index, next_question_id, answer_id) => {
    setSelectedAnswerIndex(index);
    setNextQuestionId(next_question_id);
    setAnswerId(answer_id);
  };

  const handleAnswerSelectionMulty = (
    index,
    next_question_id,
    answer_id,
    checked
  ) => {
    // функция для чекбокса
    setSelectedAnswerIndex(index);
    setNextQuestionId(next_question_id);
    setCheckedAnswers((prev) => {
      // если галочка стоит то добавляем в массив уникальных ответов
      if (checked) {
        return [...new Set([...prev, answer_id])];
      } else {
        // если убрали то удаляем
        return prev.filter((id) => id !== answer_id);
      }
    });
  };

  const handleChangeQuestion = (e) => {
    e.preventDefault();
    e.stopPropagation();
    let hasAnswer = false;
    let current_question_index = null;
    const tmp = JSON.parse(JSON.stringify({ ...editedData }));
    setQuestionIdsHistory((prev) => {
      if (!prev.includes(currentQuestionId)) {
        return [...prev, currentQuestionId];
      } else return prev;
    });
    for (let i = 0; i < tmp.questions.length; i++) {
      const element = tmp.questions[i];
      if (element.question_id === currentQuestionId) {
        current_question_index = i;
        tmp.questions[i].answers = tmp.questions[i].answers.map((el) => {
          delete el.markAsAnswer;
          delete el.details;
          if (
            el.answer_id === answerId ||
            checkedAnswers.includes(el.answer_id)
          ) {
            el.markAsAnswer = true;
            hasAnswer = true;
            if (el.is_need_details) {
              if (comments[el.answer_id] && comments[el.answer_id].length > 0) {
                el.details = comments[el.answer_id];
              } else {
                el.markAsAnswer = false;
                hasAnswer = false;
              }
            }
            if (el.next_question_id === null && hasAnswer) {
              setIsFormFilled(true);
            }
            setNextQuestionId(el.next_question_id);
          }
          return el;
        });
        break;
      }
    }
    //  проверка если хоть одно обязательное поле не заполнено
    if (
      tmp.questions[current_question_index].quetion_type_id === 3 &&
      tmp.questions[current_question_index].answers.some((answer) => {
        return (
          answer.data_type_id === 1 &&
          answer.is_need_details &&
          !answer.details &&
          !answer.markAsAnswer
        );
      })
    ) {
      setIsFormFilled(false);
      setShowRequireFieldError(true);
      return;
    }

    for (let i = 0; i < tmp.questions.length; i++) {
      const element = tmp.questions[i];
      if (nextQuestionId === null && hasAnswer) {
        setIsFormFilled(true);
      }
      if (nextQuestionId !== null && element.question_id === nextQuestionId) {
        setCurrentQuestion(element);
        break;
      }
    }
    setShowRequireFieldError(false);
    setEditedData(tmp);
    setSelectedAnswerIndex(null);
    setNextQuestionId(false);
  };
  const handleSwipeToNextQuestionReadOnly = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const tmp = JSON.parse(JSON.stringify({ ...editedData }));
    let next_question_index = null;
    for (let i = 0; i < tmp.questions.length; i++) {
      const element = tmp.questions[i];
      if (element.question_id === currentQuestionId) {
        tmp.questions[i].answers = tmp.questions[i].answers.map((el) => {
          if (el.selected) {
            next_question_index = el.next_question_id;
          }
          return el;
        });
        break;
      }
    }
    for (let i = 0; i < tmp.questions.length; i++) {
      const element = tmp.questions[i];
      if (
        next_question_index !== null &&
        element.question_id === next_question_index
      ) {
        setCurrentQuestion(element);
        break;
      }
    }
  };
  const handleSwipeToPrevQuestionReadOnly = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const tmp = JSON.parse(JSON.stringify({ ...editedData }));
    for (let i = tmp.questions.length - 1; i >= 0; i--) {
      const element = tmp.questions[i];
      element.answers.forEach((answer) => {
        if (answer.next_question_id === currentQuestionId && answer.selected) {
          setCurrentQuestion(tmp.questions[i]);
        }
      });
    }

    for (let i = 0; i < tmp.questions.length; i++) {}
  };
  const handleSwipeToPrevQuestion = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsFormFilled(false);
    const newEditedData = JSON.parse(JSON.stringify(editedData));
    const lastQuestionId = questionIdsHistory[questionIdsHistory.length - 1];
    for (let i = newEditedData.questions.length - 1; i >= 0; i--) {
      const question = newEditedData.questions[i];
      if (
        question.question_id ===
        questionIdsHistory[questionIdsHistory.length - 1]
      ) {
        const markedAnswer = newEditedData.questions[i].answers.find(
          (ans) => ans.markAsAnswer
        );
        if (markedAnswer) {
          const index = question.answers.findIndex(
            (ans) => ans.answer_id === markedAnswer.answer_id
          );
          question.answers = question.answers.map((el, idx) => {
            if (
              el.answer_id ===
                newEditedData.questions[i].answers[idx].answer_id &&
              newEditedData.questions[i].answers[idx].markAsAnswer
            ) {
              setNextQuestionId(el.next_question_id);
              if (newEditedData.questions[i].answers[idx].details) {
                el.details = newEditedData.questions[i].answers[idx].details;
                setComments((prev) => ({
                  ...prev,
                  [el.answer_id]: el.details,
                }));
              }
            }
            return el;
          });
          setCurrentQuestionId(lastQuestionId);
          setCurrentQuestion(question);
          setAnswerId(question.answers[index].answer_id);
          setSelectedAnswerIndex(index);
          setCurrentQuestion(question);
          setEditedData(newEditedData);
        }
      }
    }
    const removelastIndex = questionIdsHistory;
    removelastIndex.pop();
    setQuestionIdsHistory(removelastIndex);
  };

  useEffect(() => {
    getAnket();
  }, []);

  if (!anketData)
    return (
      <div style={{ marginTop: "10px" }}>
        <LinearLoader />
      </div>
    );

  if (anketData.errors) {
    if (anketData.error_type === "other") {
      return <ErrataView errata={anketData} />;
    }
    if (anketData.error_type === "info") {
      return <ErrataViewInfo errata={anketData} />;
    }
  }
  if (!anketData.errors) {
    return (
      <>
        <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
          {isShowFinalMessage ? (
            <div style={{ marginTop: "1rem" }}>Спасибо за ответы!</div>
          ) : isFormFilled ? (
            <div>
              <p>
                Вы ответили на все вопросы. Если необходимо внести изменения,
                нажмите обратную стрелку. Или завершите заполнение анкеты.
              </p>
              <div className={cls.anketBtns}>
                <div
                  className={cls.ellipsBtn}
                  onClick={handleSwipeToPrevQuestion}
                >
                  <div>
                    <Icon name="arrow_left" />
                  </div>
                </div>
                {isSaveLoading ? (
                  <div className={cls.ellipsLoadingBtn}>
                    <Icon name="loading" className={cls.loaadinIcon} />
                  </div>
                ) : (
                  <div className={cls.ellipsBtn}>
                    <div style={{ cursor: "pointer" }} onClick={saveAnket}>
                      Завершить
                    </div>
                  </div>
                )}
              </div>
            </div>
          ) : (
            <>
              <div>
                <p className={cls.question_text}>
                  {currentQuestion.question_text}
                </p>
                <div
                  style={{
                    marginTop: "20px",
                    display: "flex",
                    flexDirection: "column",
                    gap: "20px",
                  }}
                >
                  {currentQuestion &&
                    currentQuestion.answers.map((variants, index) => {
                      return (
                        <Answers
                          readonly={readonly}
                          currentQuestion={currentQuestion}
                          key={variants.answer_id}
                          variants={variants}
                          index={index}
                          selectedAnswerIndex={selectedAnswerIndex}
                          handleAnswerSelection={handleAnswerSelection}
                          setCurrentQuestionId={setCurrentQuestionId}
                          comment={comments[variants.answer_id]}
                          setComment={(newComment) =>
                            setComments((prev) => ({
                              ...prev,
                              [variants.answer_id]: newComment,
                            }))
                          }
                          setIsNeedDetails={setIsNeedDetails}
                          setSelectedAnswerIndex={setSelectedAnswerIndex}
                          setNextQuestionId={setNextQuestionId}
                          setAnswerId={setAnswerId}
                          handleAnswerSelectionMulty={
                            handleAnswerSelectionMulty
                          }
                          showRequireFieldError={showRequireFieldError}
                        />
                      );
                    })}
                  <div className={cls.anketBtns}>
                    {currentQuestion.question_num !== 1 && (
                      <div
                        className={cls.ellipsBtn}
                        onClick={
                          readonly
                            ? handleSwipeToPrevQuestionReadOnly
                            : handleSwipeToPrevQuestion
                        }
                      >
                        <div>
                          <Icon name="arrow_left" />
                        </div>
                      </div>
                    )}
                    {readonly ? (
                      currentQuestion.question_num !==
                        editedData.questions.length && (
                        <div
                          className={cls.ellipsBtn}
                          onClick={handleSwipeToNextQuestionReadOnly}
                        >
                          <div>
                            <Icon name="arrow_right" />
                          </div>
                        </div>
                      )
                    ) : (
                      <div
                        className={cls.ellipsBtn}
                        onClick={handleChangeQuestion}
                      >
                        <div style={{ cursor: "pointer" }}>Ответить</div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </>
    );
  }

  return null;
}
